import { render, staticRenderFns } from "./LicenceGroups.vue?vue&type=template&id=32e0cd43&scoped=true"
import script from "./LicenceGroups.vue?vue&type=script&lang=js"
export * from "./LicenceGroups.vue?vue&type=script&lang=js"
import style0 from "./LicenceGroups.vue?vue&type=style&index=0&id=32e0cd43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e0cd43",
  null
  
)

export default component.exports